import styled from 'styled-components';

export const EmployeePageContent = styled.div`
  display: flex;
  @media (max-width: ${({theme}) => theme.breakpoints.xl}) {
    flex-direction: column;
  }
`

export const EmployeePanel = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-left: 15px;

  > *:not(:last-child) {
    margin-bottom: 30px;
  }

  @media (max-width: ${({theme}) => theme.breakpoints.lg}) {
    margin-left: 0;
  }
`

